import { useSettings } from "master";

export const useContactUs = ({ load = false, key = "" }) => {
  const { settingsInfo } = useSettings({ load, key });
  return {
    settingsInfo,
  };
};
